export const isThereEvenAValue = (values) =>
  Object.values(values).some((value) => value);
